import { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Moment from "react-moment";
import { NavLink } from "react-router-dom";
import { Container, TableHead } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

function FleetStatusTable(props) {
  const [data, setData] = useState([]);
  const [start, setStart] = useState(0);
  const [finish, setFinish] = useState(100);
  const nextPage = () => {
    setStart(start + 10);
    setFinish(finish + 10);
  };

  const previousPage = () => {
    setStart(start - 10);
    setFinish(finish - 10);
  };

  useEffect(() => {
    setData(props.data.slice(start, finish));
  }, [props.data, start, finish]);
  return (
    <Container>
      <Table style={{ tableLayout: "auto" }}>
        <TableHead>
          <TableRow>
            <TableCell>Serial</TableCell>
            <TableCell>Core ID</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Firmware</TableCell>
            <TableCell>Last Heard</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.map((device, key) => (
              <TableRow key={key}>
                <TableCell>
                  <NavLink to={"/device/" + device.coreID} className="Nav_link">
                    {device.serial.replace(".", "").match(/.{3}/g).join(".")}
                  </NavLink>
                </TableCell>
                <TableCell>{device.coreID}</TableCell>
                <TableCell>{device.type}</TableCell>
                <TableCell>{device.firmware}</TableCell>
                <TableCell>
                  {device.last_heard ? (
                    <Moment format="YYYY-MM-DD HH:mm:ss Z">
                      {device.last_heard}
                    </Moment>
                  ) : (
                    <div>-</div>
                  )}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      {start !== 0 && (
        <IconButton onClick={previousPage}>
          <ArrowBackIcon />
        </IconButton>
      )}
      {finish !== 10 && start + 10 <= props.data.length && (
        <IconButton onClick={nextPage}>
          <ArrowForwardIcon />
        </IconButton>
      )}
    </Container>
  );
}

export default FleetStatusTable;
